import React from "react"
import PropTypes from "prop-types"
import ItemNameValueShape from "../../state/shapes/ItemNameValueShape"
import Widget from "../layout/widget/Widget"
import GaugeComparisonChart from "../charts/generic/GaugeComparisonChart"

function LabourTurnoverOverall({ exportEndpoint, appliedFilters, data, sampleSize }) {
  const titleKey="Widgets.LabourTurnoverOverall.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.OverallLabourTurnover.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      sampleSize={sampleSize}
    >
      <GaugeComparisonChart
        data={data}
        labelText="Widgets.LabourTurnoverOverall.Label"
        percentageBasedChart
        reverseLegend
        titleKey={titleKey}
      />
    </Widget>
  )
}

LabourTurnoverOverall.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameValueShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired
}

export default LabourTurnoverOverall



// WEBPACK FOOTER //
// ./src/components/widgets/LabourTurnoverOverall.jsx